import axios from '@/api/config';

const pcIndexV3 = {
  getDictionaryGuides(data){
      return axios.get(`${process.env.BASE_URL}/dictionary/getDictionaryGuides`, { params: data })
    },
    getDictionaryGuide(data){
      return axios.get(`${process.env.BASE_URL}/dictionary/getDictionaryGuide`, { params: data })
    },
    getNewsList(data){
      return axios.post(`${process.env.BASE_URL}/information/pageList`, data);
    },
    getInformationList(data){
      return axios.post(`${process.env.BASE_URL}/information/infomationList`, data);
    },
    getPageWidgetDetailTree(data){
      return axios.get(`${process.env.BASE_URL}/pageWidgeDetil/getPageWidgeDetilTree`, { params: data })
    },
    
    updatePageWidgeDetail(data){
      return axios.put(`${process.env.BASE_URL}/pageWidgeDetil/updatePageWidgeDetil`, data);
    },
    
    addPageWidgeDetil(data){
      return axios.post(`${process.env.BASE_URL}/pageWidgeDetil/addPageWidgeDetil`, data);
    },
}

export default pcIndexV3;



// WEBPACK FOOTER //
// ./src/api/pcIndexV3.js